export default function WhyUs() {
  const points = [
    {
      icon: 'ri-book-open-line',
      title: 'Szczegółowe przewodniki zakupowe',
      desc: 'Kompleksowe poradniki, które przeprowadzą Cię przez cały proces zakupowy – od wyboru produktu po finalizację zamówienia.',
    },
    {
      icon: 'ri-scales-3-line',
      title: 'Porównania produktów i kategorii',
      desc: 'Obiektywne zestawienia, które pomagają wybrać najlepszą opcję spośród tysięcy dostępnych produktów.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Informacje o bezpieczeństwie transakcji',
      desc: 'Sprawdzone wskazówki dotyczące bezpiecznych płatności, weryfikacji sprzedawców i ochrony kupującego.',
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Praktyczne instrukcje krok po kroku',
      desc: 'Proste i zrozumiałe instrukcje, które pomogą Ci rozpocząć przygodę z Kakobuy Spreadsheet.',
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          <div className="flex-1">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-accent-100/70 rounded-full text-xs font-medium text-accent-700 mb-4">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-heart-line text-xs"></i>
              </div>
              Zaufanie
            </div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-6">
              Dlaczego użytkownicy wybierają KakobuyPolska.skin?
            </h2>
            <p className="text-foreground-600 leading-relaxed mb-10">
              Naszym celem jest stworzenie największej polskiej bazy wiedzy dotyczącej Kakobuy Spreadsheet.
              Publikujemy szczegółowe przewodniki, porównania produktów, informacje o bezpieczeństwie
              oraz praktyczne instrukcje.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {points.map((point, idx) => (
                <div
                  key={idx}
                  className="flex items-start gap-3 p-4 bg-background-50 rounded-xl border border-background-200/60 hover:border-primary-200 transition-all duration-200"
                >
                  <div className="w-9 h-9 flex-shrink-0 flex items-center justify-center bg-primary-100 rounded-lg">
                    <i className={`${point.icon} text-sm text-primary-600`}></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-semibold text-foreground-900 mb-1">{point.title}</h4>
                    <p className="text-xs text-foreground-600 leading-relaxed">{point.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="flex-1 w-full">
            <div className="w-full h-[350px] md:h-[450px] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20modern%20workspace%20with%20laptop%20displaying%20product%20spreadsheet%20catalog%20surrounded%20by%20fashion%20items%20and%20accessories%2C%20warm%20natural%20lighting%2C%20minimal%20desk%20setup%2C%20beige%20and%20cream%20tones%2C%20editorial%20lifestyle%20photography%2C%20soft%20shadows%2C%20organized%20and%20aesthetic%20composition&width=800&height=600&seq=kakobuy-whyus-01&orientation=landscape"
                alt="KakobuyPolska.skin - Profesjonalne przewodniki i analizy"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}